export enum SpecialFilterFamilyID {
    ALL = -1,
    MY_STUFF = -2
}

export const DEFAULT_TAG_FILTER_ID = 0;



// WEBPACK FOOTER //
// ./src/_stores/CollectionFilterStore.ts